// extracted by mini-css-extract-plugin
export default {"flexTextarea":"styles_flexTextarea__blSdP","textarea":"styles_textarea__CGP-v"};